import * as React from "react";
import { BarChart } from "@mui/x-charts/BarChart";

import { useSelector } from "react-redux";

export default function BarsDataset({ dataset, series, chartSetting }) {
  const isLoading = useSelector((state) => state.statistiqueReducer.isloading);
  return (
    <div className="d-flex justify-content-center">
      <BarChart
        loading={isLoading ? true : false}
        dataset={dataset}
        xAxis={[
          {
            scaleType: "band",
            dataKey: "month",
            valueFormatter: (month) => {
              return month;
            },
          },
        ]}
        series={series}
        {...chartSetting}
      />
    </div>
  );
}
